import { Store } from 'vuex';
import * as ErrorStore from '@/store/modules/error';

export function initOnFullFilled<T>(
  store: Store<T>,
  callback: Function = () => {}
) {
  return config => {
    callback();

    // @ts-ignore
    const $vm = store._vm;

    store.dispatch(
      ErrorStore.ClearErrors(null, { namespace: ErrorStore.namespace })
    );

    if ($vm.$Progress) $vm.$Progress.start();

    return config;
  };
}
